<div class="toolbar-user" (prepClickOutside)="onClickOutside()" fxFlex="grow">
  <!-- Toggle Button for Resource Menu -->
  <button #triggerBtn id="resource-menu-button" class="button" mat-button (click)="toggleDropdown()" [class.open]="isOpen" fxFlex="grow"
    aria-label="Resource Menu" [matTooltip]="LangTextData.tooltipLabel.resourceMenu"
    matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below" aria-haspopup="menu"
    [attr.aria-expanded]="isOpen" aria-controls="resource-menu" type="button">
    <span fxLayout="row" fxLayoutAlign="start center" style="color: #136ef8;">
      <mat-icon aria-hidden="true">video_library</mat-icon>
      &nbsp;&nbsp;<strong>{{LangTextData.htmlLabel.resourceText}}</strong>
    </span>
  </button>
  <!-- Dropdown Menu -->
  <div #menuPanel *ngIf="isOpen" class="dropdown" [class.open]="isOpen" id="resource-menu" role="menu"
    aria-label="Resources menu" (keydown)="onMenuKeydown($event)"
    style="background-color: #f9f9f9;">
    <div class="content">
      <div class="list">
        <div class="list-item" matRipple role="menuitem" tabindex="-1" (click)="clickGoToTraning()"
          (keydown.enter)="clickGoToTraning()" (keydown.space)="$event.preventDefault(); clickGoToTraning()"
          [aria-label]="LangTextData.htmlLabel.resourceTutorial">
          <mat-icon class="list-item-icon" aria-hidden="true">open_in_new</mat-icon>
          <span class="youtube_link">{{LangTextData.htmlLabel.resourceTutorial}}</span>
        </div>
        <mat-divider></mat-divider>
        <div class="list-item" matRipple role="menuitem" tabindex="-1" (click)="clickGoTpQuickStartGuide()"
          (keydown.enter)="clickGoTpQuickStartGuide()" (keydown.space)="$event.preventDefault(); clickGoTpQuickStartGuide()"
          [aria-label]="LangTextData.htmlLabel.resourceOnboardDoc">
          <mat-icon class="list-item-icon" aria-hidden="true">open_in_new</mat-icon>
          <span class="youtube_link">{{LangTextData.htmlLabel.resourceOnboardDoc}}</span>
        </div>
        <mat-divider></mat-divider>
        <div class="list-item" matRipple role="menuitem" tabindex="-1"
          [attr.aria-expanded]="isSubmenuOpen"
          (click)="$event.stopPropagation(); toggleSubmenu()"
          (keydown.enter)="$event.stopPropagation(); toggleSubmenu()"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation(); toggleSubmenu()"
          [aria-label]="LangTextData.htmlLabel.resourceVideo">
          <mat-icon class="list-item-icon" aria-hidden="true">video_file</mat-icon>
          <span>{{LangTextData.htmlLabel.resourceVideo}}</span>
          <div class="submenu-trigger">
            <mat-icon aria-hidden="true">arrow_drop_down</mat-icon>
          </div>
        </div>
        <!-- Submenu -->
        <div class="submenu" *ngIf="isSubmenuOpen" role="group" aria-label="Video tutorials">
          <div class="submenu-item" matRipple role="menuitem" tabindex="-1" (click)="clickSubmenuItem('item1')"
            (keydown.enter)="clickSubmenuItem('item1')" (keydown.space)="$event.preventDefault(); clickSubmenuItem('item1')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem1}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="-1" (click)="clickSubmenuItem('item2')"
            (keydown.enter)="clickSubmenuItem('item2')" (keydown.space)="$event.preventDefault(); clickSubmenuItem('item2')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem2}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="-1" (click)="clickSubmenuItem('item3')"
            (keydown.enter)="clickSubmenuItem('item3')" (keydown.space)="$event.preventDefault(); clickSubmenuItem('item3')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem3}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="-1" (click)="clickSubmenuItem('item4')"
            (keydown.enter)="clickSubmenuItem('item4')" (keydown.space)="$event.preventDefault(); clickSubmenuItem('item4')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem4}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="-1" (click)="clickSubmenuItem('item5')"
            (keydown.enter)="clickSubmenuItem('item5')" (keydown.space)="$event.preventDefault(); clickSubmenuItem('item5')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem5}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="-1" (click)="clickSubmenuItem('item6')"
            (keydown.enter)="clickSubmenuItem('item6')" (keydown.space)="$event.preventDefault(); clickSubmenuItem('item6')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem6}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="-1" (click)="clickSubmenuItem('item7')"
            (keydown.enter)="clickSubmenuItem('item7')" (keydown.space)="$event.preventDefault(); clickSubmenuItem('item7')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem7}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="-1" (click)="clickSubmenuItem('item8')"
            (keydown.enter)="clickSubmenuItem('item8')" (keydown.space)="$event.preventDefault(); clickSubmenuItem('item8')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem8}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>